module.exports = __webpack_public_path__ + "img/card-access.618aaf4c.svg";